const PaymentMethod = require('./paymentMethod');
const ProfileUser = require('./profileUser');

function ProfileData(key, profile) {
    let profileData = profile || {};
    this.id = key;
    this.address1 = profileData.address1;
    this.address2 = profileData.address2;
    this.city = profileData.city;
    this.companyName = profileData.companyName;
    this.country = profileData.country;
    this.firstName = profileData.firstName;
    this.lastName = profileData.lastName;
    this.name = profileData.name;
    this.tva = profileData.tva;
    this.type = profileData.type;
    this.zipCode = profileData.zipCode;
    this.paymentMethods = profileData.paymentMethods !== undefined &&  profileData.paymentMethods !== null ? profileData.paymentMethods.map(p => new PaymentMethod(p)): [];
    this.status = profileData.status;
    this.users = profileData.users !== undefined &&  profileData.users !== null ? profileData.users.map(p => new ProfileUser(p)): [];
    this.pictureUrl = profileData.pictureUrl;
}

module.exports = ProfileData;